/**
 * @desc 导出财务税务公司间交易表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.stockOccupyDetail.exportFinanceAndCompanyReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/exportFinanceAndCompanyReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
